import config from '@/common/config';
import { approval, rebuy } from '@/features/account-abstraction/constants/abis';
import { AccountAbstractionState } from '@/features/account-abstraction/store/AccountAbstractionContext';
import { PaymasterMode, createSessionSmartAccountClient, getBatchSessionTxParams } from '@biconomy/account';
import { polygon } from 'viem/chains';
import { encodeFunctionData, parseUnits } from 'viem/utils';

const withSponsorship = {
  paymasterServiceData: {
    mode: PaymasterMode.SPONSORED,
  },
};
export async function rebuyTableContract(
  accountAbstractionState: AccountAbstractionState,
  tableId: bigint,
  buyin: string,
) {
  if (accountAbstractionState.smartWalletAddress && tableId && buyin) {
    // #region Batch Session

    const batchSession = accountAbstractionState?.rebuyBatchSession;

    const emulatedUsersSmartAccount = await createSessionSmartAccountClient(
      {
        accountAddress: batchSession.sessionStorageClient.smartAccountAddress, // Dapp can set the account address on behalf of the user
        bundlerUrl: process.env.REACT_APP_BICONOMY_BUNDLER_URL || '',
        biconomyPaymasterApiKey: process.env.REACT_APP_BICONOMY_PAYMASTER_API_KEY,
        chainId: config.chain?.id,
      },
      batchSession,
      true,
    );

    const buyInWithDecimals = parseUnits(buyin, config.usdtDecimals);

    const rebuyTableTx = {
      to: config.contracts.tables,
      data: encodeFunctionData({
        abi: rebuy,
        functionName: 'rebuy',
        args: [tableId, buyInWithDecimals],
      }),
    };
    const approvalUsdtTx = {
      to: config.contracts.usdt,
      data: encodeFunctionData({
        abi: approval,
        functionName: 'approve',
        args: [config.contracts.tables, buyInWithDecimals],
      }),
    };

    const batchSessionParams = await getBatchSessionTxParams(
      [approvalUsdtTx, rebuyTableTx],
      [0, 1],
      // Order must match the order in which corresponding policies were set
      batchSession, // Storage client, full Session or simply the smartAccount address if using default storage for your environment
      polygon,
    );

    const { waitForTxHash } = await emulatedUsersSmartAccount.sendTransaction([approvalUsdtTx, rebuyTableTx], {
      ...batchSessionParams,
      ...withSponsorship,
    });

    const tx = await waitForTxHash();
    return tx;
  }
}
